import React from 'react';
import { Container, Row, Col ,Button} from 'react-bootstrap';
import '../../components/css/wh_bank_with_us.css'
import whyBankWithUsImages from "../../assets/static/transfer.webp";

const WhyBankWithUs = () => {
  return (
 <Container fluid className="bg-white px-0">
  <Container className="px-0 px-md-3">
    <Row className="flex-column-reverse flex-md-row mx-0">
      
      <Col md={6} className="d-flex align-items-start px-2 px-md-3">
        <div className="content">
          <h2>Personal Banking Experience</h2>
          <h1>Why Choose Kontriman Cooperative Credit Union?</h1>
          <p>
            We’re more than just a place to bank; we’re a partner in your financial journey. 
            By choosing us, you’re choosing a financial institution that values your success, 
            your security, and your future.
          </p>
          <ul className="bullet-points">
            <li><strong>Savings Account</strong>: Create a Savings account in seconds</li>
            <li><strong>Deposit Account</strong>: Create a Deposit account in seconds</li>
            <li><strong>Credit Account</strong>: Create a Credit account in seconds</li>
            <li>Other Products and Services:</li>
            <li>Pay Bills Online</li>
            <li>Internet Banking</li>
            <li>Mobile Banking</li>
            <li>Virtual Cards</li>
          </ul>
          <a href="/personal-banking">
            <Button className="mt-3 custom-button">
              Discover more on Personal account
            </Button>
          </a>
        </div>
      </Col>

      <Col md={6} className="d-flex align-items-start px-0 px-md-3">
        <div className="images w-100">
          <img 
            src={whyBankWithUsImages} 
            alt="Sample" 
            className="img-fluid w-100"
          />
        </div>
      </Col>

    </Row>
  </Container>
</Container>
  );
}

export default WhyBankWithUs;
